import React from 'react';
import { Container, Typography } from '@mui/material';

const About = () => {
  const montserratFont = '"Montserrat", sans-serif';

  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: 'calc(100vh - 80px)',
        paddingBottom: '80px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        backgroundColor: '#fafafa',
        color: '#333',
        fontFamily: montserratFont,
      }}
    >
      <div style={{ textAlign: 'center', margin: '60px 0' }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            color: '#2a3d56',
            fontWeight: 'bold',
            marginBottom: '30px',
            letterSpacing: '0.05em',
            fontFamily: montserratFont,
          }}
        >
          Om Oss
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#4a4a4a',
            lineHeight: 1.9,
            fontSize: 18,
            maxWidth: 700,
            margin: '0 auto 20px auto',  // margin-bottom: 20px
            letterSpacing: '0.02em',
            fontFamily: montserratFont,
          }}
        >
          <strong style={{ color: '#0066cc' }}>DesignLocker</strong> erbjuder ett exklusivt sortiment av noggrant utvalda produkter med modern design och hög kvalitet. Produkterna tillverkas och levereras via en pålitlig extern partner, vilket säkerställer en effektiv produktion och leverans.
        </Typography>

        <Typography
          variant="h4"
          component="h2"
          sx={{
            color: '#2a3d56',
            fontWeight: 700,
            marginTop: '60px',   // Mer luft ovanför rubriken
            marginBottom: '30px',
            fontSize: '1.75rem',
            letterSpacing: '0.04em',
            fontFamily: montserratFont,
          }}
        >
          Vårt Företag
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#4a4a4a',
            lineHeight: 1.9,
            fontSize: 18,
            maxWidth: 700,
            margin: '0 auto',
            letterSpacing: '0.02em',
            fontFamily: montserratFont,
          }}
        >
          Vi samarbetar med en extern leverantör för att garantera att varje produkt håller högsta möjliga standard. Vårt fokus ligger på att erbjuda dig en smidig och pålitlig köpupplevelse med produkter som kombinerar kvalitet, funktionalitet och design.
        </Typography>
      </div>
    </Container>
  );
};

export default About;
